/**
 * Statuses where no app server answered: no connection (0), a timeout, a rate limit, a gateway/proxy
 * failure, or a captive portal asking for sign-in (511).
 */
const UNREACHABLE_STATUSES: ReadonlyArray<number> = [0, 408, 429, 502, 503, 504, 511];

/** The request never got an answer from the app, so it says nothing about the session; retry it as-is. */
export const isServerUnreachable = (error: SerializableError | null | undefined): boolean =>
  typeof error?.status === 'number' && UNREACHABLE_STATUSES.includes(error.status);
